module.exports = __webpack_public_path__ + "static/media/hero.aa41ff31.jpg";